// ChildModal.jsx
import React, { useState, useEffect } from 'react';
import ChildDetails from './ChildDetails';
import ChildRegistration from './ChildRegistration';
import ChildHistory from './ChildHistory';
import { useChild } from './hooks/useChild';
import '../../../kindergartens/detail/components/ApplicationCard/ApplicationModal.css'
import './ChildModal.css';

const ChildModal = ({ 
  isOpen, 
  onClose, 
  childId,
  mode = 'view'
}) => {
  const [activeTab, setActiveTab] = useState('details');
  const { child, loading, error, refetch } = useChild(childId);
  const [documentError, setDocumentError] = useState(null);

  useEffect(() => {
    if (isOpen && childId) {
      refetch();
      setActiveTab('details');
    }
  }, [isOpen, childId, refetch]);

  if (!isOpen) return null;

  const tabs = [
    { id: 'details', label: 'Загальна інформація' },
    { id: 'registration', label: 'Проживання та реєстрація' },
    { id: 'history', label: 'Історія' },
  ];

  const handleClose = () => {
    setActiveTab('details');
    onClose();
  };

  if (loading) {
    return (
      <div className="modal-overlay" onClick={handleClose}>
        <div className="child-modal" onClick={(e) => e.stopPropagation()}>
          <div className="modal-content">
            <div className="text-center p-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Завантаження...</span>
              </div>
              <p className="mt-2">Завантаження даних дитини...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="modal-overlay" onClick={handleClose}>
        <div className="child-modal" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h2 className="modal-title">Помилка</h2>
            <button className="close-button" onClick={handleClose}>×</button>
          </div>
          <div className="modal-content">
            <div className="alert alert-danger m-3">
              <strong>Помилка завантаження даних дитини:</strong> {error}
              <div className="mt-2">
                <button className="btn btn-sm btn-outline-danger" onClick={refetch}>
                  Спробувати знову
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!child) {
    return (
      <div className="modal-overlay" onClick={handleClose}>
        <div className="child-modal" onClick={(e) => e.stopPropagation()}>
          <div className="modal-content">
            <div className="alert alert-warning m-3">
              Дані дитини не знайдені
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="child-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title-section">
            <h2 className="modal-title">{child.fullName}</h2>
            <span className={`status-badge ${child.statusClass}`}>
              {child.status}
            </span>
            {child.currentKindergarten && (
              <span className="kindergarten-badge">
                {child.currentKindergarten}
              </span>
            )}
          </div>
          <button className="close-button" onClick={handleClose}>
            ×
          </button>
        </div>

        <div className="modal-tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="modal-content">
          {activeTab === 'details' && (
            <ChildDetails 
              childData={child} 
              mode={mode}
            />
          )}
          
          {activeTab === 'registration' && (
            <ChildRegistration 
              childData={child} 
              mode={mode}
              childId={childId}
            />
          )}
          
          {activeTab === 'history' && (
            <ChildHistory 
                childData={child} 
                mode={mode}
                onDocumentError={setDocumentError}
            />
            )}
            {documentError && (
                <div className="alert alert-warning m-3">
                    <strong>Помилка завантаження документів:</strong> {documentError}
                    <button 
                    className="btn btn-sm btn-outline-warning ms-2"
                    onClick={() => setDocumentError(null)}
                    >
                    ×
                    </button>
                </div>
            )}
        </div>

        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={handleClose}>
            Закрити
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChildModal;